import React from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { GatsbyImage } from "gatsby-plugin-image"
import { Link } from "gatsby"
import formatDate from "../../lib/formatDate"

const BlogItem = ({ post }) => (
  <article className="bg-gray-100 p-3 mb-4 rounded-lg">
    <Link to={post?.path?.alias}>
      <h2 className="text-lg text-(--color-brown-light)">{post?.title}</h2>
    </Link>
    {post?.relationships?.field_media && (
      <GatsbyImage
        image={
          post?.relationships?.field_media?.relationships?.field_media_image
            ?.localFile?.childImageSharp?.gatsbyImageData
        }
      />
    )}
    <div
      dangerouslySetInnerHTML={{
        __html: post && post.body && post.body.value.substring(0, 200),
      }}
    />

    <div className="flex justify-between mb-4">
      <Link
        to={post?.path?.alias}
        className="text-(--color-brown-light) transition-colors hover:text-(--color-brown) hover:underline font-bold"
      >
        Подробнее{" "}
        <FontAwesomeIcon
          icon="chevron-right"
          className="text-(--color-brown-light)"
        />
      </Link>
      <div className="flex gap-1 items-center text-(--color-brown-light) font-bold">
        <FontAwesomeIcon icon="clock" />
        {post?.created && (
          <span className="whitespace-nowrap">{formatDate(post?.created)}</span>
        )}
      </div>
    </div>

    <div className="flex gap-4 mb-2">
      <div className="flex gap-1 flex-wrap align-center">
        <FontAwesomeIcon
          icon="tags"
          size="lg"
          className="text-(--color-brown-light)"
        />
        {post?.relationships?.field_tags.map(tag => (
          <Link key={tag?.name} to={tag?.path?.alias} className="text-white">
            <div className="bg-(--color-brown-light) transition-colors hover:bg-(--color-brown)  p-1 text-sm rounded-sm">
              {tag?.name}
            </div>
          </Link>
        ))}
      </div>
    </div>
  </article>
)

export default BlogItem
